export const inputInjectionKey = Symbol('input');
